var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import * as React from 'react';
import classnames from 'classnames';

import LoadingIndicator from './LoadingIndicator';
import './LoadingIndicatorWrapper.scss';

var CENTER = 'center';
var TOP = 'top';

var LoadingIndicatorWrapper = function LoadingIndicatorWrapper(_ref) {
    var children = _ref.children,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        _ref$crawlerPosition = _ref.crawlerPosition,
        crawlerPosition = _ref$crawlerPosition === undefined ? CENTER : _ref$crawlerPosition,
        _ref$crawlerSize = _ref.crawlerSize,
        crawlerSize = _ref$crawlerSize === undefined ? 'default' : _ref$crawlerSize,
        _ref$isLoading = _ref.isLoading,
        isLoading = _ref$isLoading === undefined ? false : _ref$isLoading,
        _ref$hideContent = _ref.hideContent,
        hideContent = _ref$hideContent === undefined ? false : _ref$hideContent,
        rest = _objectWithoutProperties(_ref, ['children', 'className', 'crawlerPosition', 'crawlerSize', 'isLoading', 'hideContent']);

    var crawlerPositionClassName = classnames('loading-indicator-veil', {
        'is-with-top-crawler': crawlerPosition === TOP,
        'is-with-center-crawler': crawlerPosition === CENTER
    }, hideContent ? 'hide-content' : 'blur-content');
    return React.createElement(
        'div',
        _extends({ className: 'loading-indicator-wrapper ' + className }, rest),
        children,
        isLoading && React.createElement(
            'div',
            { className: crawlerPositionClassName },
            React.createElement(LoadingIndicator, { size: crawlerSize })
        )
    );
};

LoadingIndicatorWrapper.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    crawlerPosition: PropTypes.oneOfType([PropTypes.any, PropTypes.any]),
    crawlerSize: PropTypes.oneOf(['small', 'medium', 'large', 'default']),
    isLoading: PropTypes.bool,
    hideContent: PropTypes.bool
};
export default LoadingIndicatorWrapper;
import PropTypes from 'prop-types';